import React, { useContext, memo } from "react";
import {
  InfoWindow
} from "@react-google-maps/api";
import { WebMapContext } from "../WebMapGoogleMap";
import { SiteType } from "../../../../constants/WebMap";
import SiteTooltip from "../../../../components/elements/SiteTooltip";

const OprtSiteTooltipSection = ({
  operatorSiteTooltipData,
  eyeIcons,
  setOperatorSiteTooltipData,
  operatorsPermittedOpSite
}) => {
  const {
    selectedOperatorSiteOperator
  } = useContext(WebMapContext);

  return (
    operatorSiteTooltipData
      ? <InfoWindow
        position={{
          lat: operatorSiteTooltipData.latitude,
          lng: operatorSiteTooltipData.longitude,
        }}
        onCloseClick={() => {
          setOperatorSiteTooltipData(null);
        }}
        options={{
          disableAutoPan: true,
          pixelOffset: new window.google.maps.Size(0, -20),
        }}
      >
        <div>
          {eyeIcons.sites && (
            <SiteTooltip
              type={SiteType.OperatorSite}
              selectedOperator={selectedOperatorSiteOperator}
              data={operatorSiteTooltipData}
              operatorsPermittedOpSite={operatorsPermittedOpSite}
            />
          )}
        </div>
      </InfoWindow>
      : <></>
  )
};

export default memo(OprtSiteTooltipSection);